export default __webpack_public_path__ + "static/media/htb-marieli.36910209.jpg";